import { render } from "./editAttrType.vue?vue&type=template&id=0e090941&scoped=true"
import script from "./editAttrType.vue?vue&type=script&lang=js"
export * from "./editAttrType.vue?vue&type=script&lang=js"

import "./editAttrType.vue?vue&type=style&index=0&id=0e090941&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e090941"],['__file',"src/views/brandProduct/components/editAttrType.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0e090941"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0e090941', __exports__)) {
    console.log('reload')
    api.reload('0e090941', __exports__)
  }
  
  module.hot.accept("./editAttrType.vue?vue&type=template&id=0e090941&scoped=true", () => {
    console.log('re-render')
    api.rerender('0e090941', render)
  })

}


export default __exports__